export const removeDuplicatesFromArray = element => {
  // Option 1: the implemented
  // Option 2 (old school): element.filter((v,i) => element.indexOf(v) === i)
  return [...new Set(element)];
};
